require("./app");
var OTP_TIMER = 60;

new Vue({
    el: "#staffLogin",
    data: {
        mobileNumberForOTP: "",
        sessionId: "",
        toggleMobileOTPSection: true,
        country: {
            callingCode: "+91",
            flagImgUrl: process.env.MIX_SERVICE_URL + "countries_flag/IN.png",
        },
        staffMobile: "",
        staffMobileOtp: "",
        countryList: [],
        resendTimer: OTP_TIMER,
        timerId: "",
        resendDisable: false,
    },
    mounted() {
        this.getCountryList();
    },
    methods: {
        getCountryList() {
            this.$http.get("/country/list").then((response) => {
                this.countryList = response.body.result;
            });
        },
        startTimer: function() {
            this.resendTimer = OTP_TIMER;
            this.timerId = setInterval(() => {
                this.resendTimer = this.resendTimer - 1;
                if (this.resendTimer <= 0) {
                    this.removeTimer();
                }
            }, 1000);
        },
        removeTimer: function() {
            clearInterval(this.timerId);
        },
        onCountryCodeChange: function(value) {
            this.mobileNumberForOTP = "";
        },
        sendStaffMobileNumberForOTP: function() {
            var isValid = validate.formIsValid("staffLoginMobileForm");
            if (isValid) {
                var sendStaffMobileNumberForOTPLadda = Ladda.create(
                    document.querySelector("#sendStaffMobileNumberForOTPBtn")
                );
                sendStaffMobileNumberForOTPLadda.start();
                this.$http
                    .post("/staff/login/send-otp", {
                        countryCode: this.country.callingCode,
                        mobile: this.mobileNumberForOTP,
                    })
                    .then(
                        (response) => {
                            if (!response.body.hasError) {
                                this.sessionId = response.body.result.sessionId;
                                this.toggleMobileOTPSection = false;
                                toastr.success(response.body.message);
                                sendStaffMobileNumberForOTPLadda.stop();
                                this.startTimer();
                            } else {
                                sendStaffMobileNumberForOTPLadda.stop();
                                if (
                                    response.body.error ===
                                        "CSRF token mismatch." ||
                                    response.body.error ===
                                        "User session still active"
                                ) {
                                    window.location.href = "/";
                                } else {
                                    toastr.error(response.body.message);
                                }
                            }
                        },
                        (error) => {
                            sendStaffMobileNumberForOTPLadda.stop();
                            toastr.error("SOMETHING WENT WRONG");
                            console.log("SOMETHING WENT WRONG", error);
                        }
                    );
            }
        },
        sendOTPForVerification: function() {
            var isValid = validate.formIsValid("staffLoginOTPform");
            if (isValid) {
                var sendOTPForVerificationLadda = Ladda.create(
                    document.querySelector("#sendOTPForVerificationBtn")
                );
                sendOTPForVerificationLadda.start();
                this.$http
                    .post("/staff/login", {
                        otp: this.staffMobileOtp,
                        sessionId: this.sessionId,
                        mobile: this.mobileNumberForOTP,
                        countryCode: this.country.callingCode,
                    })
                    .then(
                        (response) => {
                            if (!response.body.hasError) {
                                sendOTPForVerificationLadda.stop();
                                window.location.href =
                                    "/staff/authorize/center";
                            } else {
                                sendOTPForVerificationLadda.stop();
                                toastr.error(response.body.message);
                            }
                        },
                        (error) => {
                            sendOTPForVerificationLadda.stop();
                            console.log("SOMETHING WENT WRONG", error);
                            toastr.error("SOMETHING WENT WRONG");
                        }
                    );
            }
        },
        resendStaffMobileForOTP: function() {
            this.resendDisable = true;
            this.$http
                .post("/staff/login/resend-otp", {
                    countryCode: this.country.callingCode,
                    seesionId: this.sessionId,
                    mobile: this.mobileNumberForOTP,
                })
                .then(
                    (response) => {
                        if (!response.body.hasError) {
                            toastr.success(response.body.message);
                            this.sessionId = response.body.result.sessionId;
                            this.startTimer();
                            this.resendDisable = false;
                        } else {
                            toastr.error(response.body.message);
                            this.resendDisable = false;
                        }
                    },
                    (error) => {
                        console.log("SOMETHING WENT WRONG", error);
                    }
                );
        },
        goBack: function() {
            // this.countryCode = "+91";
            this.sessionId = "";
            this.staffMobileOtp = "";
            this.toggleMobileOTPSection = true;
            // this.mobileNumberForOTP = "";
        },
    },
});
